module.exports = __webpack_public_path__ + "static/media/club-manager.b1677755.svg";